// Read more
const readmoreEl = document.querySelector('.readmore');
if (readmoreEl) {
  readmoreEl.onclick = function(e) {
    document.querySelector('article').style.height = 'auto';
    e.currentTarget.classList.add('hidden');
    const tocEl = document.querySelector('.table-of-contents');
    if (tocEl) tocEl.classList.add('active');
  };
}

// Click readmore button if content type is PR or paginated
if (document.querySelector('article').dataset.contentType === 'pr' || document.querySelectorAll('.pagination-top').length > 0) {
  document.querySelector('article').style.height = 'auto';
  const readmoreEl = document.querySelector('.readmore');
  if (readmoreEl) readmoreEl.classList.add('hidden');
  const tocEl = document.querySelector('.table-of-contents');
  if (tocEl) tocEl.classList.add('active');
}

// Table-of-contents
const tocEls = document.querySelectorAll('.table-of-contents a');
tocEls.forEach((tocEl) => {
  tocEl.onclick = function(e) {
    e.preventDefault();
    const headerSize = document.getElementById('header').clientHeight;
    const offsetTop = document.querySelector(e.currentTarget.hash).offsetTop;
    window.scrollTo({ top: offsetTop - headerSize + 20, behavior: 'smooth' });
  };
});

// Send log
const paths = window.location.pathname.split('/');
const contentType = paths[1].match(/^\d+$/) ? 'article' : paths[1];
const contentId = paths[1].match(/^\d+$/) ? paths[1] : (paths.length >= 3 ? paths[2] : '');
let unreadPositionList = [...Array(101).keys()].filter((i) => i > 0 && i % 5 == 0);
let unreadRecommendAreaContentsList = [...Array(24).keys()].filter((i) => i % 2 == 1);

const sendLogToBigquery = (logType, eventType = '', eventId = '', eventName = '', abtestTitle = '', listIndex = '') => {
  if (logType !== 'read_ratio') {
    gtag('event', logType, {
      content_type: contentType,
      content_id: contentId,
      event_type: eventType,
      event_id: encodeURIComponent(eventId),
      event_name: encodeURIComponent(eventName),
      list_index: listIndex,
      abtest_title: encodeURIComponent(abtestTitle),
      tl_uuid: _tl_uuid
    });
  }

  const src =
    "/logging?log_type=" + logType +
    "&content_type=" + contentType +
    "&content_id=" + contentId +
    "&url=" + (encodeURIComponent(location.pathname + location.search)) +
    "&event_type=" + eventType +
    "&event_id=" + (encodeURIComponent(eventId)) +
    "&event_name=" + (encodeURIComponent(eventName)) +
    "&list_index=" + listIndex +
    "&abtest_title=" + (encodeURIComponent(abtestTitle));

  const target = document.getElementsByTagName('script')[0] || document.head;
  const script = document.createElement('script');
  script.src = src;
  target.parentNode.insertBefore(script, target);
};

const getArticleHeight = (ratio = 100) => {
  const articleEl = document.querySelector('article');
  const targetHeight = articleEl.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) + articleEl.offsetHeight;
  return (targetHeight - document.getElementById('header').clientHeight) * (ratio / 100);
};

const getScrollBottomPosition = () => {
  const docEl = document.documentElement;
  return docEl.scrollTop + docEl.clientHeight - document.getElementById('header').clientHeight - document.getElementById('footer-menu').clientHeight;
};

if (window.location.pathname.match(/\/preview\//) === null) {
  // Send read ratio log of position 0%
  sendLogToBigquery('read_ratio', 0);
  window.addEventListener('scroll', function(e) {
    if (document.querySelector('.recommend-area').classList.contains('hidden')) {
      return;
    }

    // Send read ratio log per position
    if (unreadPositionList[0] && (document.querySelector('.readmore').classList.contains('hidden') || document.documentElement.clientWidth > 768)) {
      unreadPositionList = unreadPositionList.filter((position) => {
        if (getScrollBottomPosition() > getArticleHeight(position)) {
          sendLogToBigquery('read_ratio', position);
          return false;
        } else {
          return position;
        }
      });
    }

    // Send read ratio log of recommends until recommend row 12
    if (unreadRecommendAreaContentsList[0]) {
      unreadRecommendAreaContentsList = unreadRecommendAreaContentsList.filter((num) => {
        const recommendArea = document.querySelectorAll('.recommend-area-inner .list-box')[num];
        const docEl = document.documentElement;
        const scrollHeight = docEl.scrollTop + docEl.clientHeight - document.getElementById('footer-menu').clientHeight;
        const targetHeight = recommendArea.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) + recommendArea.clientHeight;

        if (recommendArea && scrollHeight > targetHeight) {
          sendLogToBigquery('read_ratio', 'recommend_row_' + (Math.ceil(num / 2)));
          return false;
        } else {
          return num;
        }
      });
    }
  });
}

